export enum SHIPMENT_LOCATION_STATUS {
  ACTIVE = 'ACTI',
  REQUEST = 'RQST',
}
